export default class LatLon {
    constructor(readonly lat: number, readonly lon: number, readonly radius?: number) {}
    distanceTo = function (point, precision?) {
        function toRad(n) {
            return n * Math.PI / 180;
        }
        function toPrecisionFixed(num, p) {
            return parseFloat(parseFloat(num).toPrecision(p));
        }
        let r = this.radius || 6371; // earth's mean radius in km
        let lat1 = toRad(this.lat), lon1 = toRad(this.lon);
        let lat2 = toRad(point.lat), lon2 = toRad(point.lon);
        let dLat = lat2 - lat1;
        let dLon = lon2 - lon1;
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1) * Math.cos(lat2) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = r * c;
        // default 4 sig figs reflects typical 0.3% accuracy of spherical model
        return toPrecisionFixed(d, precision || 4);
    };
}